import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileDropDirective } from './file-drop.directive';
import { FileDropZoneDirective } from './file-drop-zone/file-drop-zone.directive';
import { FileDropComponent } from './file-drop.component';

@NgModule({
  declarations: [FileDropDirective, FileDropZoneDirective, FileDropComponent],
  imports: [CommonModule],
  exports: [FileDropDirective, FileDropZoneDirective, FileDropComponent],
})
export class FileDropModule {}
